import type { FC } from "react";

import classNames from "classnames";

import type { IDashboardWidgetInterface } from "app/components/widget/utils/DashboardWidgetsInterfaces-v2";

export const SingleMetricCpcTemplateV2: FC<IDashboardWidgetInterface> = (props) => {
    const { widget, data } = props;
    return (
        <div>
            {data.CPC.indexOf(" - ") === -1 ? (
                <div className="large-single-number u-blueMediumMedium gt-vlarge-screen lt-vlarge-screen">
                    ${data.CPC}
                </div>
            ) : null}
            {data.CPC.indexOf(" - ") > -1 ? (
                <div
                    className={classNames("large-single-number u-blueMediumMedium gt-vlarge-screen lt-vlarge-screen", {
                        narrow: widget?.pos?.sizeX === 1,
                    })}
                >
                    {data.CPC.split(" - ")[0]}$ - {data.CPC.split(" - ")[1]}$
                </div>
            ) : null}
        </div>
    );
};
